// MainMultimedia
//  => Multimedia Select - (Select)
//    => Lazy Loading
//  => Multimedia Upload - (Save)

import {Component, OnDestroy, OnInit} from '@angular/core';
import {MultimediamanagementService} from '../services/multimediamanagement.service';
import {ResponseModel} from 'src/app/common/models/ResponseModel';
import {MultiMediaBasicInfo} from 'src/app/common/models/MultiMediaBasicInfo';
import {ParentMessageType} from 'src/app/common/models/ParentMessage';
import {ParentCommunicatorService} from 'src/app/services/parent-communicator.service';
import {PopupBaseComponent} from '../../popup-base/popup-base.component';
import {MultimediaPopupInputInfo} from 'src/app/common/models/PopupInputInfo';
import {MultimediaPopupOpenMode, PopupResponseEvents, ResourceType} from 'src/app/common/enums/enums';
import {MultimediaPopupResponse} from 'src/app/common/models/PopupResponse';
import {OverlayService} from 'src/app/services/UI/overlay.service';
import {CropFrameMode} from '../../../../common/enums/enums';
import {LoadingService} from 'src/app/services/UI/loading.service';
import {CustomError} from 'src/app/common/helpers/custom-error';
import {ConfirmationInputInfo} from 'src/app/common/models/ConfirmationInputInfo';
import {ConfirmationContent} from 'src/app/common/models/ConfirmationContent';
import {MediaReferences} from 'src/app/common/models/MediaReferences';
import {GuidGenerator} from 'src/app/common/helpers/guid-generator';
import {ConfirmationDialogService} from 'src/app/services/UI/confirmation-dialog.service';
import {first} from 'rxjs/operators';
import {MultiMediaFilter} from 'src/app/common/helpers/filter';
import {TranslateService} from '@ngx-translate/core';
import {TranslateHandler} from 'src/app/common/helpers/translate-handler';


@Component({
    selector: 'app-mainmultimedia',
    templateUrl: './mainmultimedia.component.html',
    styleUrls: ['./mainmultimedia.component.scss'],
    standalone: false
})

export class MainmultimediaComponent extends PopupBaseComponent implements OnInit, OnDestroy {

  // isMultiMediaPanelOpen: boolean;
  isMultiMediaUploadOpen: boolean = false;
  lazyLoadingList: MultiMediaBasicInfo[] = [];
  lazyLoadingDisplayImageItems: any[] = [];
  lazyLoadingListFilter: any[] = [];
  selectedImages: number[];
  selectedPerson: string;
  searchText: string = '';
  selectedImageCaption: string = '';
  // title: string = 'add_media';
  addTitle: string = '';
  editTitle: string = '';
  titleBelongsTo: string = '';
  imageDeselected: boolean = false;
  imageError: boolean = false;
  isSaveEnable: boolean = false;
  cropFrameMode: CropFrameMode;
  parentReload: boolean;
  acceptedMultimediaTypes: number[];
  popUpTitle: string;
  isFullScreenPopUp: boolean;
  multimediaFilterMode: any;
  deleteMediaId: number = 0;

  marignWidth: number = 50;
  panelWidth: number;
  popupWidth: string;
  popupStyle: string;
  multimediaPopupMode: any;

  filterTypes = [];

  selectedMultimedia: MultiMediaBasicInfo;
  editMultimedia: MultiMediaBasicInfo;
  multimediaServiceSubscription: any;
  confirmationServiceSubscription: any;

  resourceType: string = ResourceType[ResourceType.Multimedia];

  constructor(private multimediaManagementService: MultimediamanagementService,
    private parentCommunicatorService: ParentCommunicatorService,
    overlayService: OverlayService,
    private loadingService: LoadingService,
    private translateService: TranslateService,
    private confirmationDialogService: ConfirmationDialogService,
    private translateHandler: TranslateHandler) {
    super(multimediaManagementService, overlayService);

  }

  ngOnInit(): void {
    super.ngOnInit();
    this.display();
    this.filterTypes = MultiMediaFilter.getFilters();
  }

  display() {
    this.isSaveEnable = false;
    this.lazyLoadingDisplayImageItems = [];
    this.multimediaServiceSubscription = this.multimediaManagementService.onVisibilityChanged() // OnVisibilityChanged()
      .subscribe((MultimediaInputresponse: MultimediaPopupInputInfo) => {
        if (MultimediaInputresponse.visibility) {
          this.selectedImages = [];
          this.addTitle = MultimediaInputresponse.Title;
          this.editTitle = this.translateHandler.translate('lbl_edit_profile_picture_of', [MultimediaInputresponse.TitleBelongsTo])
          this.selectedImages = MultimediaInputresponse.SelectedImageIds;
          this.cropFrameMode = MultimediaInputresponse.CropFrameMode;
          this.acceptedMultimediaTypes = MultimediaInputresponse.AcceptedMultimediaTypes;
          this.popUpTitle = MultimediaInputresponse.PopUpTitle;
          this.isFullScreenPopUp = MultimediaInputresponse.IsFullScreenPopUp;
          this.popupWidth = MultimediaInputresponse.PopupWidth;
          this.panelWidth = Number(this.popupWidth.replace('%', ''));
          this.multimediaPopupMode = MultimediaInputresponse.Mode;
          this.setPopupStyle(this.panelWidth);
          if (MultimediaInputresponse.Mode === MultimediaPopupOpenMode.List) {
            this.multimediaFilterMode = MultimediaInputresponse.FilterMode;
            this.loadMultimediaToList();
          }
          else // Show Edit upload view
          {
            this.isMultiMediaUploadOpen = true;
            if (MultimediaInputresponse.Mode === MultimediaPopupOpenMode.Edit) {
              this.editMultimedia = MultimediaInputresponse.MediaToEdit;
            }
          }
        }
      },
        (err) => {
          throw new CustomError("MainmultimediaComponent => Display() : " + err, 911, false);
        });
  }

  setPopupStyle(panelWidth: number) {
    this.popupStyle = (panelWidth > this.marignWidth) ? "main" : "short";
  }

  sortSelectedImagesFirst(multiMediaBasicInfo: MultiMediaBasicInfo[]): MultiMediaBasicInfo[] {
    if (this.selectedImages !== undefined
      && this.selectedImages.length > 0
      && multiMediaBasicInfo.length > 0) {
      let itemsInSelected = multiMediaBasicInfo.filter(s => this.selectedImages.includes(s.id));
      let itemsNotInSelected = multiMediaBasicInfo.filter(s => !this.selectedImages.includes(s.id));
      let merged = itemsInSelected.concat(itemsNotInSelected);
      return merged;
    }

    return multiMediaBasicInfo;
  }

  changeTabAndRefresh() {
    this.loadMultimediaToList();
  }

  openEditUploadTab() {
    this.isMultiMediaUploadOpen = !this.isMultiMediaUploadOpen;
  }


  clearSearch() {
    this.lazyLoadingDisplayImageItems = this.lazyLoadingListFilter;
  }

  showNotImplemented() {
    this.parentCommunicatorService.send(ParentMessageType.ShowInformation, 'not_implemented');
  }

  selectedImage(selectedMediaInfo: any) {
    let item = selectedMediaInfo.item;
    this.selectedMultimedia = item;
    this.imageDeselected = selectedMediaInfo.isDeselect;
    this.imageError = selectedMediaInfo.isErrorItem;

    this.isSaveEnable = selectedMediaInfo.isSaveEnable;


    if (item) {
      if (item.caption && !this.imageDeselected) {
        this.selectedImageCaption = item.caption;
      }
      else if (item.fileName && !this.imageDeselected) {
        this.selectedImageCaption = item.fileName;
      }
      else {
        this.selectedImageCaption = '';
      }
    } else {
      this.selectedImageCaption = '';
    }
  }

  editImage(editMediaInfo: any) {
    this.isMultiMediaUploadOpen = true;
    this.editMultimedia = new MultiMediaBasicInfo;
    this.editMultimedia = editMediaInfo;
  }

  selected() {
    this.isSaveEnable = false;

    this.selectedImageCaption = '';
    let popupResponse = new MultimediaPopupResponse();
    popupResponse.Status = this.imageDeselected ? PopupResponseEvents.DeSelected : (this.imageError ? PopupResponseEvents.Error : PopupResponseEvents.Selected);
    popupResponse.Data.push(this.selectedMultimedia);

    this.multimediaManagementService.setSelection(popupResponse);
    this.multimediaManagementService.changeVisibility(false, null);
  }

  clearEditingMultimedia(event: any) {
    this.isMultiMediaUploadOpen = false;

    if (this.multimediaPopupMode
      && this.multimediaPopupMode === MultimediaPopupOpenMode.Edit) {
      this.editted(event);
    }
    else {
      this.editMultimedia = new MultiMediaBasicInfo();
    }
  }

  editted(editedMedia: MultiMediaBasicInfo) {
    this.isSaveEnable = false;

    this.selectedImageCaption = '';
    let popupResponse = new MultimediaPopupResponse();
    popupResponse.Status = PopupResponseEvents.Edited;
    popupResponse.Data.push(editedMedia);
    this.multimediaManagementService.setSelection(popupResponse);
    this.multimediaManagementService.changeVisibility(false, null);
  }

  cancel() {
    this.isSaveEnable = false;

    this.selectedImageCaption = '';
    let popupResponse = new MultimediaPopupResponse();
    popupResponse.Status = PopupResponseEvents.Cancelled;
    popupResponse.reload = this.parentReload;
    this.multimediaManagementService.onCancelled(popupResponse);
  }

  ngOnDestroy() {
    this.multimediaServiceSubscription.unsubscribe();
    this.confirmationServiceSubscription.unsubscribe();
  }

  reload(reload) {
    this.parentReload = reload;
  }

  loadMultimediaToList() {
    this.isMultiMediaUploadOpen = false;

    this.multimediaManagementService.getIndividualMultiMediaData(null).subscribe((response: ResponseModel<MultiMediaBasicInfo[]>) => {

      if (response.errors) {
        throw response.errors;
      }
      if (response.data) {
        this.lazyLoadingList = response.data.filter(x => this.multimediaFilterMode.some(y => y === x.mediaType));
        let sortedList = this.sortSelectedImagesFirst(this.lazyLoadingList);
        this.lazyLoadingDisplayImageItems = sortedList;
        this.lazyLoadingListFilter = sortedList;
      }
    },
      (err) => {
        throw new CustomError('MainmultimediaComponent => Display() : ' + err, 911, false);
      });
  }

  deleteMedia(item) {
    let processId = GuidGenerator.generate();
    this.loadingService.show(processId);
    this.multimediaManagementService.getMediaReferences(item.id).subscribe((response: ResponseModel<MediaReferences>) => {
      let references = response.data;
      this.loadingService.hide(processId);
      this.showDeleteConfirmation(item, references);
    },
      (err) => {
        this.loadingService.hide(processId);
        throw new CustomError("MainlazyloadingComponent => OpenConsent() : " + err, 911, false);
      });
  }

  //Show delete confirmation popup
  showDeleteConfirmation(item, references) {
    let confirmationDialogHeader = 'lbl_delete_confiramation_header';
    let confirmationDialogfooter = 'cnf_delete_confirmation';
    let confirmationDialogBody = this.prepareMiddleMessage(references);

    let popupInputData = new ConfirmationInputInfo();
    popupInputData.Visibility = true;
    let confirmationContent = new ConfirmationContent();
    confirmationContent.ConfirmationDialogHeader = confirmationDialogHeader;
    confirmationContent.ConfirmationDialogBody = confirmationDialogBody;
    confirmationContent.ConfirmationDialogFooter = confirmationDialogfooter;
    popupInputData.ConfirmationContent = confirmationContent;

    this.confirmationServiceSubscription = this.confirmationDialogService.OpenPopup(popupInputData)
      .pipe(first())
      .subscribe((response: boolean) => {
        if (response) {
          this.deleteMultimedia(item.id);
        } else {
          this.deleteMediaId = 0;
        }
      }, (err) => {
        throw new CustomError("MultimediaComponent => ShowDeleteConfirmation() : " + err, 911, false);
      }
      );
  }

  //Delete selected media file
  deleteMultimedia(mediaId) {
    let processId = GuidGenerator.generate();
    this.loadingService.show(processId);
    this.multimediaManagementService.deleteIndividualMultiMediaData(mediaId)
      .pipe(first())
      .subscribe((response: any) => {
        this.loadingService.hide(processId);
        this.deleteMediaId = mediaId;
      },
        (err) => {
          this.loadingService.hide(processId);
          throw new CustomError("MultimediaComponent => DeleteMultimedia() : " + err, 911, false);
        });
  }

  //Prepare custom message for delete confirmation related to multimedia reference
  prepareMiddleMessage(references: MediaReferences) {
    let message = this.translateService.instant('cnf_delete_multimedia_confirmation_message') + ' ';

    if (references.total > 0) {
      let includeComma: boolean = false;
      if (references.individuals.length > 0) {
        message += this.translateHandler.translate('lnk_members', [references.individuals.length.toString()])
        includeComma = true;
      }
      if (references.families.length > 0) {
        message += (includeComma ? ', ' : '') + this.translateHandler.translate('lnk_families', [references.families.length.toString()])
        includeComma = true;
      }
      if (references.places.length > 0) {
        message += (includeComma ? ', ' : '') + this.translateHandler.translate('lnk_places', [references.places.length.toString()])
        includeComma = true;
      }
      if (references.sources.length > 0) {
        message += (includeComma ? ', ' : '') + this.translateHandler.translate('lnk_sources', [references.sources.length.toString()])
        includeComma = true;
      }
    }
    return message;
  }

}
